export const AppRoute = {
  TOOLS_AI_HOMEWORK_HELP_ANSWER: {
    path: '/answer',
    name: 'AI Homework Help',
  },
};

export const ParentRoute = {
  HOME: {
    path: process.env.REACT_APP_WP_DOMAIN_LINK,
    name: 'Home',
  },
};

export enum SearchParam {
  NEW_REQUEST = 'new_request',
  INCOMING_REQUEST = 'incoming_request',
  JUST_AUTH = 'user_just_auth',
  JUST_COME_AFTER_PAY = 'just_come_after_pay',
}
